import React from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'

const mapToCSSModule = (styles, classes, theme) => {
  return classNames(
    theme,
    'button',
    [...((Array.isArray(classes) && classes) || [classes])].map(c => `button-${c}`),
    styles,
  )
  // return classNames(
  //   theme['button'],
  //   [...((Array.isArray(classes) && classes) || [classes])].map(c => theme[`button-${c}`]),
  //   [...((Array.isArray(styles) && styles) || [styles])].map(c => theme[c])
  // )
}

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  getRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  onClick: PropTypes.func,
  classes: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  children: PropTypes.node,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  theme: PropTypes.object.isRequired,
}

class Button extends React.Component {
  static defaultProps = {
    tag: 'button',
  }

  onClick = e => {
    if (this.props.disabled) {
      e.preventDefault()
      return
    }

    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  render() {
    const {
      classes,
      styles,
      theme,
      resource, // Just swallow this
      tag,
      getRef,
      ...attributes
    } = this.props

    let Tag = tag

    if (attributes.href && Tag === 'button') {
      Tag = 'a'
    }

    return (
      <Tag
        type={Tag === 'button' && attributes.onClick ? 'button' : undefined}
        {...attributes}
        className={mapToCSSModule(styles, classes, theme)}
        ref={getRef}
        onClick={this.onClick}
      />
    )
  }
}

Button.propTypes = propTypes

export default Button



// WEBPACK FOOTER //
// ./ui/Button/Button.js